export default function ConfirmAnswerButton() {
    return <svg data-name="confirm-answer-btn">
        <path className="cls-19" d="M.07,8.06,33,128.32a1.47,1.47,0,0,0,1.84,1L139.54,96.74a1.46,1.46,0,0,0,1-1.66L126.64,1.22A1.48,1.48,0,0,0,125.11,0L1.4,6.16A1.47,1.47,0,0,0,.07,8.06Z"/>
        <path className="cls-3" d="M105.2,55.19,70.64,29.73C61,22.61,52.88,25.56,51.44,36v67c1.44,10.48,9.51,13.44,19.2,6.3L105.2,83.86C115.89,76,115.89,63.09,105.2,55.19Z"/>
        <path className="cls-4" d="M104.19,41.93,69.63,16.47c-9.69-7.12-17.76-4.17-19.2,6.31v67c1.44,10.48,9.51,13.44,19.2,6.3L104.19,70.6C114.88,62.72,114.88,49.83,104.19,41.93Z"/>
    </svg>;
}
